import React, { useState } from "react";
import "./../../../styles/details.css";
import { Container, Row, Col } from "reactstrap";
import Booking from "./../../../components/Booking/Booking";
import tour1 from "./../../../assets/images/city-palace-banner.jpg";
import tour7 from "./../../../assets/images/img07.webp";
import tour2 from "./../../../assets/images/img02.webp";
import tour3 from "./../../../assets/images/img03.webp";
import tour4 from "./../../../assets/images/img04.webp";
import tour5 from "./../../../assets/images/img05.webp";
import tour6 from "./../../../assets/images/img06.webp";

import tourcard2 from "./../../../assets/images/jaipur-village-safari-THUMB.jpg";
import tourcard3 from "./../../../assets/images/night-2.jpg";
import Newsletter from "../../../shared/Newsletter";
import ImageGallery from "../../../components/Gallery/Gallery2";
import { Helmet } from "react-helmet";
import Subtitle from "../../../shared/Subtitle";
import Tours from "../../../components/RelatedTours/Tours";
import { useNavigate } from "react-router-dom";

const JaipurSightseeing = () => {
  const images = [tour7, tour2, tour3, tour4, tour5, tour6];
  const faqData = [
    {
      question: "What is the special attraction of Jaipur?",
      answer:
        "Jaipur's special attraction is the Amber Fort, a majestic hilltop fort offering panoramic views and showcasing rich Rajput architecture. Hawa Mahal, City Palace, and Jantar Mantar are also iconic landmarks.",
    },
    {
      question: "Which thing is most famous in Jaipur?",
      answer:
        "Jaipur is famous for its royal heritage and palaces, especially the Pink City’s vibrant architecture and its status as a UNESCO World Heritage site.",
    },
    {
      question: "What is famous in Jaipur to eat?",
      answer:
        "Dal Baati Churma, a traditional Rajasthani dish, and Laal Maas, a spicy mutton curry, are must-try dishes in Jaipur. The traditional Rajasthani thali should also be tried.",
    },
    {
      question: "Which bazaar is famous in Jaipur?",
      answer:
        "Johari Bazaar is the most famous market in Jaipur, known for its exquisite jewelry, especially gold, silver, and gemstones.",
    },
    {
      question: "Which sweet is famous in Jaipur?",
      answer:
        "Ghevar, a disc-shaped sweet made with flour and soaked in sugar syrup, is a popular dessert in Jaipur, especially during festivals.",
    },
    {
      question: "What is the traditional dress in Jaipur?",
      answer:
        "The traditional dress for men in Jaipur is the Angrakha and Dhoti or Kurta with a safa (turban), while women wear Ghagra Choli or Saree adorned with intricate embroidery.",
    },
    {
      question: "What should we wear in Jaipur?",
      answer:
        "Comfortable and modest clothing is ideal. Lightweight cotton clothes are suitable due to the hot climate. For visiting temples or forts, it’s recommended to wear covered clothing.",
    },
    {
      question: "What is special in Jaipur for ladies?",
      answer:
        "Jaipur is a shopping paradise for women, offering handcrafted jewelry, block-printed textiles, Leheriya sarees, bandhani dupattas, and traditional Mojari footwear.",
    },
    {
      question: "Is Jaipur safe for females at night?",
      answer:
        "Jaipur is relatively safe for females, but like in any city, it's advised to stay in well-lit and populated areas at night, avoid secluded areas, and use trusted transportation.",
    },
    {
      question: "Does Jaipur have nightlife?",
      answer:
        "Jaipur has a modest nightlife, with options like bars, pubs, and cultural shows at heritage hotels. However, the city is more known for its historical and cultural experiences than its nightlife.",
    },
  ];

  const tourData = [
    {
      name: "JAIPUR JEEP SAFARI",
      category: "Jaipur Tour Packages",
      luggage: "Luggage: 1 Large Suitcase + 2 Small Bags",
      image: tourcard2,
    },
    {
      name: "OPEN-AIR NIGHT TOUR OF JAIPUR CITY",
      category: "Jaipur Tour Packages",
      luggage: "Luggage: 1 Large Suitcase + 2 Small Bags",
      image: tourcard3,
    },
  ];

  // Function to navigate to the tour details page
  const navigate = useNavigate();
  const navigateToTourDetails = (tourCategory, tourName) => {
    const categorySlug = tourCategory.split(" ").join("-").toLowerCase();
    const tourNameSlug = tourName.split(" ").join("-").toLowerCase();
    navigate(`/tour-packages/${categorySlug}/${tourNameSlug}`);
  };

  const [activeQuestion, setActiveQuestion] = useState(null);

  const toggleAccordion = (index) => {
    setActiveQuestion(activeQuestion === index ? null : index);
  };

  return (
    <>
      <Helmet>
        <title>Jaipur Sightseeing Day Tour | The Rustic Paths</title>
        <meta name="author" content="The Rustic Paths" />
        <meta
          name="description"
          content="Dive into the royal heritage and vibrant culture of Jaipur
                      with our exclusive Jaipur Private Day Tour. Enjoy a
                      seamless, curated experience as you explore the Pink
                      City's most iconic landmarks, all in a single day."
        />
        <meta name="image" content={tour1} />

        <script type="application/ld+json">
          {`
      {
        "@context": "https://schema.org",
        "@type": "TouristAttraction",
        "name": "Jaipur Sightseeing Day Tour",
        "image": "${tour1}",
        "description": "Dive into the royal heritage and vibrant culture of Jaipur with our exclusive Jaipur Private Day Tour. Enjoy a seamless, curated experience as you explore the Pink City's most iconic landmarks.",
        "touristType": "Travelers",
        "location": {
          "@type": "Place",
          "name": "Jaipur",
          "address": "Jaipur, Rajasthan, India"
        },
        "openingHours": "Mo,Tu,We,Th,Fr,Sa,Su 00:00-23:59"
      }
    `}
        </script>

        <script type="application/ld+json">
          {`
      {
        "@context": "https://schema.org",
        "@type": "TouristDestination",
        "name": "Jaipur",
        "image": "${tour1}",
        "description": "Jaipur is known for its royal heritage and iconic landmarks such as Amer Fort, Hawa Mahal, and City Palace.",
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": "26.9124",
          "longitude": "75.7873"
        }
      }
    `}
        </script>

        <script type="application/ld+json">
          {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "The Rustic Paths",
        "image": "${tour1}",
        "description": "The Rustic Paths offers curated tours across India with experienced drivers and guides, providing private and customizable travel experiences.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "The Rustic Paths, H NO 49 PHOOL BAG, Near Gas Agency, Amer, Rajasthan 302028.",
          "addressLocality": "Amer",
          "addressRegion": "Rajasthan",
          "postalCode": "302028",
          "addressCountry": "IN"
        },
        "telephone": "+91-7297075173",
        "openingHours": "Mo,Tu,We,Th,Fr,Sa,Su 00:00-23:59",
        "priceRange": "$$",
        "url": "https://www.therusticpaths.com"
      }
    `}
        </script>

        <script type="application/ld+json">
          {`
      {
        "@context": "https://schema.org",
        "@type": "Itinerary",
        "name": "Jaipur Sightseeing Day Tour Itinerary",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "item": {
              "@type": "TouristAttraction",
              "name": "Amer Fort",
              "description": "A majestic blend of Hindu and Mughal architecture."
            }
          },
          {
            "@type": "ListItem",
            "position": 2,
            "item": {
              "@type": "TouristAttraction",
              "name": "Jal Mahal",
              "description": "An enchanting water palace situated in the middle of Man Sagar Lake."
            }
          },
          {
            "@type": "ListItem",
            "position": 3,
            "item": {
              "@type": "TouristAttraction",
              "name": "Hawa Mahal",
              "description": "The Palace of Winds with a unique five-story façade."
            }
          },
          {
            "@type": "ListItem",
            "position": 4,
            "item": {
              "@type": "TouristAttraction",
              "name": "Nahargarh Fort",
              "description": "A fort offering panoramic views of Jaipur."
            }
          }
        ]
      }
    `}
        </script>

        <script type="application/ld+json">
          {`
      {
        "@context": "https://schema.org",
        "@type": "TouristTrip",
        "name": "Jaipur Sightseeing Day Tour",
        "itinerary": {
          "@type": "Itinerary",
          "name": "Jaipur Sightseeing Day Tour Itinerary",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "item": {
                "@type": "TouristAttraction",
                "name": "Amer Fort"
              }
            },
            {
              "@type": "ListItem",
              "position": 2,
              "item": {
                "@type": "TouristAttraction",
                "name": "Jal Mahal"
              }
            },
            {
              "@type": "ListItem",
              "position": 3,
              "item": {
                "@type": "TouristAttraction",
                "name": "Hawa Mahal"
              }
            },
            {
              "@type": "ListItem",
              "position": 4,
              "item": {
                "@type": "TouristAttraction",
                "name": "Nahargarh Fort"
              }
            }
          ]
        },
        "offers": {
          "@type": "Offer",
          "price": "99.00",
          "priceCurrency": "USD",
          "validFrom": "2024-01-01",
          "url": "https://www.therusticpaths.com/tour-packages/same-day-tour-packages/jaipur-sightseeing-day-tour"
        }
      }
    `}
        </script>

        <script type="application/ld+json">
          {`
      {
        "@context": "https://schema.org",
        "@type": "Trip",
        "name": "Jaipur Sightseeing Day Trip",
        "description": "A one-day curated tour of Jaipur's most iconic landmarks with a private guide.",
        "offers": {
          "@type": "Offer",
          "price": "99.00",
          "priceCurrency": "USD",
          "validFrom": "2024-01-01",
          "url": "https://www.therusticpaths.com/tour-packages/same-day-tour-packages/jaipur-sightseeing-day-tour"
        },
        "hasPart": {
          "@type": "TouristTrip",
          "name": "Jaipur Sightseeing Day Tour"
        }
      }
    `}
        </script>
      </Helmet>
      <h1 className="centered-title text-3xl font-bold mt-6 mb-4">
        Jaipur Sightseeing Day Tour
      </h1>
      <section>
        <Container>
          <Row>
            <Col lg="12" className="details__container mx-auto">
              <img src={tour1} alt="" />
            </Col>

            <Col lg="8">
              <div className="details__container mx-auto">
                <div className="details__info">
                  <div className="mb-4 ">
                    <h2
                      className="text-xl font-semibold"
                      style={{ textAlign: "left" }}
                    >
                      Destinations Covered:
                    </h2>
                    <ul className="list-disc pl-4">
                      <li>Jaipur - Sightseeing</li>
                    </ul>
                  </div>

                  <p className="mb-4">Duration: Full Day Trip</p>

                  <div className="mb-4">
                    <h2
                      className="text-xl font-semibold "
                      style={{ textAlign: "left" }}
                    >
                      Overview:
                    </h2>
                    <p>
                      Dive into the royal heritage and vibrant culture of Jaipur
                      with our exclusive Jaipur Private Day Tour. Enjoy a
                      seamless, curated experience as you explore the Pink
                      City's most iconic landmarks, all in a single day.
                    </p>
                  </div>

                  <div className="mb-4">
                    <h2
                      className="text-xl font-semibold"
                      style={{ textAlign: "left" }}
                    >
                      Trip Highlights:
                    </h2>
                    <ul className="list-disc pl-4">
                      <li>
                        Explore the majestic Amer Fort, a stunning blend of
                        Hindu and Mughal architecture.
                      </li>
                      <li>
                        Capture breathtaking views of Jal Mahal, the enchanting
                        water palace.
                      </li>
                      <li>
                        Visit the iconic Hawa Mahal, designed for royal ladies
                        to watch street festivities.
                      </li>
                      <li>
                        Witness a spectacular sunset over Jaipur from the
                        historic Nahargarh Fort.
                      </li>
                    </ul>
                  </div>

                  <div>
                    <h2
                      className="text-xl font-semibold"
                      style={{ textAlign: "left" }}
                    >
                      Detailed Itinerary:
                    </h2>

                    {/* Day 1 */}
                    <div>
                      <details className="mb-6">
                        <summary className="text-lg font-semibold">
                          7:00 AM: Effortless Pickup & Amer Fort
                        </summary>
                        <p>
                          Begin your day with a convenient pickup from your
                          hotel by our friendly guide and driver. Your journey
                          starts with a visit to the majestic Amer Fort. Set
                          against the backdrop of rugged hills, this fort is a
                          stunning blend of Hindu and Mughal architecture.
                          Explore its ornate palaces, intricate carvings, and
                          the stunning Sheesh Mahal (Mirror Palace).
                        </p>
                      </details>

                      <details className="mb-6">
                        <summary className="text-lg font-semibold">
                          10:00 AM: Jal Mahal and Hawa Mahal
                        </summary>
                        <p>
                          Next, stop at Jal Mahal, the enchanting water palace
                          situated in the middle of Man Sagar Lake. Capture
                          breathtaking photos of this architectural marvel
                          before heading to Hawa Mahal, the Palace of Winds.
                          Admire its unique five-story façade, designed to allow
                          royal ladies to observe street festivities while
                          remaining unseen.
                        </p>
                      </details>

                      <details className="mb-6">
                        <summary className="text-lg font-semibold">
                          11:30 AM: City Palace and Jantar Mantar
                        </summary>
                        <p>
                          Continue your tour with a visit to the City Palace, a
                          splendid complex that includes gardens, courtyards,
                          and museums showcasing royal artifacts. Nearby,
                          discover Jantar Mantar, an astronomical observatory
                          filled with massive instruments that reveal the
                          scientific prowess of 18th-century India.
                        </p>
                      </details>

                      <details className="mb-6">
                        <summary className="text-lg font-semibold">
                          <strong>Afternoon:</strong> 1:00 PM: Lunch and Albert
                          Hall Museum
                        </summary>
                        <p>
                          Relish a delicious lunch at a local restaurant,
                          indulging in the rich flavors of Rajasthani cuisine.
                          Post-lunch, head to the Albert Hall Museum. This
                          magnificent museum, housed in a grand Indo-Saracenic
                          building, showcases an extensive collection of
                          artifacts, including paintings, jewelry, and
                          sculptures.
                        </p>
                      </details>

                      <details className="mb-6">
                        <summary className="text-lg font-semibold">
                          3:30 PM: Nahargarh Fort
                        </summary>
                        <p>
                          Head to Nahargarh Fort, where you can enjoy panoramic
                          views of Jaipur. Witness the sunset over the Pink City
                          from this stunning vantage point.
                        </p>
                      </details>

                      <details className="mb-6">
                        <summary className="text-lg font-semibold">
                          <strong>Evening:</strong> 5:30 PM: Shopping at a Local
                          Bazaar and Comfortable Drop-Off
                        </summary>
                        <p>
                          Conclude your day with some leisure time at the local
                          bazaar, known for its vibrant market atmosphere and
                          wide array of handicrafts, textiles, and souvenirs.
                          After shopping, our guide and driver will ensure a
                          comfortable drop-off at your hotel.
                        </p>
                      </details>

                      <p>
                        This same-day Jaipur tour provides you with the
                        opportunity to witness some of India's most famous
                        landmarks and historical sites. It's a journey through
                        time and culture, allowing you to experience the
                        grandeur and beauty of these iconic locations.
                      </p>

                      {/* Continue adding details for other days as required */}
                    </div>
                    {/* Continue adding details for other days as required */}
                  </div>
                  <Col lg="12">
                    <h2>Image Gallery</h2>
                    <ImageGallery images={images} />
                  </Col>

                  <Col lg="12">
                    {/* Add the ElfSight testimonial widget div */}
                    <div className="elfsight-app-67d8eea9-b408-49ad-8765-9edf92c75e9a"></div>
                  </Col>
                </div>
              </div>
            </Col>

            <Col lg="4">
              <Booking />
            </Col>
          </Row>
          <Col lg="12" className="mt-4">
            <Subtitle subtitle={"You may also explore"} />
            <Tours
              currentTours={tourData}
              navigateToTourDetails={navigateToTourDetails}
            />
          </Col>
          <section>
        <Col lg="12">
          <h2 className="centered-title">Frequently Asked Questions</h2>
          {faqData.map((faq, index) => (
            <div
              key={index}
              className={`faq-item ${activeQuestion === index ? "active" : ""}`}
              onClick={() => toggleAccordion(index)}
            >
              <div className="faq-question">
                {faq.question}
                <span className="arrow">
                  {activeQuestion === index ? "▼" : "▶"}
                </span>
              </div>
              {activeQuestion === index && (
                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </Col>
      </section>
        </Container>
      </section>
      
      <Newsletter />
    </>
  );
};

export default JaipurSightseeing;
